import { render } from "./OpTrankAdd.vue?vue&type=template&id=8e6fff1a"
import script from "./OpTrankAdd.vue?vue&type=script&lang=js"
export * from "./OpTrankAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__